const cornerType = {
    rectangular: 0,
    rounded: 10,
    capsule: 20
};

export default cornerType;
